import { render, staticRenderFns } from "./CreateOrderMovement.vue?vue&type=template&id=631776ae&scoped=true"
import script from "./CreateOrderMovement.vue?vue&type=script&lang=js"
export * from "./CreateOrderMovement.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderMovement.vue?vue&type=style&index=0&id=631776ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631776ae",
  null
  
)

export default component.exports